export default "__VITE_ASSET__DiYB1suR__"